import RecoverStep from "../recover_step";
import {convertAutoStopValueToMinutes, validateAutoStop} from "../../../../modules/helpers/vo-helper";
import {startRunbook} from "../../utils/recover_utils";
import {ZERO} from "../../../../modules/constants";

const TEMPLATE = 'virtualization-failover-vms-autostop';

export default class SetVoVmsAutoStop extends RecoverStep {

  constructor() {
    super(TEMPLATE);
    this.dateInput = null;
    this.timeInput = null;
  }

  open(data, el, fr, previousStep) {
    if (data.recovery.virtualization.isTest === ZERO) {
      data.recovery.virtualization.autostopEnabled = false;
      fr.goTo('setVirtualizationRunbook');
    } else {
      fr.render('setVoVmsAutoStop');
    }
  }

  postRender(data, el, fr) {
    const radioButtons = document.querySelectorAll('.autostop-options axs-radio');
    radioButtons.forEach(radioButton => {
      radioButton.addEventListener('change', (e) => {
        const autoStopValue = e.target.value;
        data.recovery.virtualization.autostop = autoStopValue;
        document.querySelector('.autostop-options .autostop-params').classList.remove('invisible');
        if (autoStopValue === '0') {
          document.querySelector('.autostop-options .autostop-params').classList.add('invisible');
          document.getElementById('vo-autostop-next-btn').disabled = false;
        }
      });
    });

    const alert = document.getElementById('failover-autostop-info');
    alert.renderBodyAsText = false;

    this.dateInput = document.querySelector('.autostop-options axs-input[type="date"]');
    this.timeInput = document.querySelector('.autostop-options axs-input[type="time"]');
    this.dateInput.addEventListener('axsInputChanged', () => {
      this.clearInputErrors(this.dateInput);
      this.proceedDateTimeValidation(data);
    });
    this.timeInput.addEventListener('axsInputChanged', () => {
      this.clearInputErrors(this.timeInput);
      this.proceedDateTimeValidation(data);
    });
  }

  transitionBack(data, el, fr) {
    if (data.runbookId) {
      fr.goTo('setRunbookVirtualizationType');
    } else {
      fr.goTo('setVirtualizationType');
    }
  }

  transitionNext(data, el, fr) {
    const isValidValue = this.proceedDateTimeValidation(data);
    if (!isValidValue && data.recovery.virtualization.autostop !== '0') {
      return;
    }
    if (data.runbookId) {
      const nextButton = document.getElementById('vo-autostop-next-btn');
      nextButton.disabled = true;
      startRunbook(
        fr,
        data.clientId,
        data.runbookId,
        data.recovery.virtualization.type,
        data.password,
        convertAutoStopValueToMinutes(data.recovery.virtualization.autoStopValue),
        function(rv, status) {
          data.recovery.virtualization.runbook = {
            id: data.runbookId,
            name: 'RUNBOOK'
          };
          fr.goTo('createRunbookFailover');
        }
      );
    } else {
      fr.goTo('setVirtualizationRunbook');
    }
  }

  proceedDateTimeValidation(data) {
    const autostop = validateAutoStop(this.dateInput, this.timeInput);
    this.handleAutoStopValue(data, autostop);
    return autostop !== null;
  }

  handleAutoStopValue(data, value) {
    const nextButton = document.getElementById('vo-autostop-next-btn');
    if (!value) {
      nextButton.disabled = true;
    } else {
      nextButton.disabled = false;
      data.recovery.virtualization.autoStopValue = value;
    }
  }

  clearInputErrors(input) {
    input.status = "";
    input.message = "";
  }
}
